import React, { useState } from "react";
import "./newFrais.scss";

import { Close, SchoolOutlined } from "@mui/icons-material";

import "react-phone-input-2/lib/style.css";
import { IconButton } from "@mui/material";
import {
  classeType,
  requestType,
  schooYearType,
} from "../../../types/GlobalType";
import { catchErrorApiCall } from "../../../_services/apiUtils";
import toast, { LoaderIcon } from "react-hot-toast";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller";
import { accountService } from "../../../_services/accountServices";
import ErrorBar from "../../../component/errorComp/ErrorBar.tsx";
import MyLoading from "../../../component/loader/MyLoading.tsx";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dataClasse: classeType[];
  dataYear: schooYearType[];
  dispatchReload: () => void;
}
const NewFrais = (props: Props) => {
  const [classeDesignation, setclasseDesignation] = useState("");
  const [anneeDesignation, setanneeDesignation] = useState("");
  const [montantDesignation, setmontantDesignation] = useState("");
  const [isValidNumber, setIsValidNumber] = useState(true);

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  // Function to handle input change
  const handleInputChange = (event) => {
    const value = event.target.value;
    setmontantDesignation(value);

    // Check if the input value is a valid number
    const isNumber = !isNaN(value) && value.trim() !== "";
    setIsValidNumber(isNumber);
  };

  const handleAddMontant = async () => {
    if (classeDesignation === "") {
      return setState({
        ...state,
        errorMessage: "Veuiller selectionner une classe",
      });
    }

    if (anneeDesignation === "") {
      return setState({
        ...state,
        errorMessage: "Veuiller selectionner l'année scolaire en cours",
      });
    }
    if (montantDesignation.toString().length < 1) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez le montant",
      });
    }
    if (!isValidNumber) {
      return setState({
        ...state,
        errorMessage: "Veuiller complétez un montant valide",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    try {
      let data = {
        montant: montantDesignation,
        classe_id: classeDesignation,
        annee_scolaire_id: anneeDesignation,
      };
      const response = await API_CONFIG.MONTANT_ANNUEL.create(data, token);
      if (response.data.status === 201) {
        toast.success("Montant annuel ajouté avec succes", {
          duration: 3000,
        });
        setmontantDesignation("");
        props.setOpen(false);
        props.dispatchReload();
      } else if (response.data.status === 205) {
        return setState({
          ...state,
          isLoading: false,
          errorMessage:
            "Montant existant pour la classe et l'année selectionnées",
        });
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });
      catchErrorApiCall(error);
    }
  };

  return (
    <>
      <div className="NewFrais">
        <div className="dialog_update">
          <div className="headerUpdate">
            <div className="titleUpdate">
              <div className="left_">
                <SchoolOutlined className="ico" />
                <span>Enregistrement - Frais scolaire</span>
              </div>
              <IconButton>
                <Close className="ico" onClick={() => props.setOpen(false)} />
              </IconButton>
            </div>
          </div>

          <div className="body_update">
            {state.errorMessage && <ErrorBar title={state.errorMessage} />}
            <div className="item">
              <label>Classe</label>
              <div className="role-selector">
                <select
                  value={classeDesignation}
                  onChange={(e) => setclasseDesignation(e.target.value)}
                  className="input-field"
                >
                  <option value="">--Selectionner une classe--</option>;
                  {props.dataClasse.map((item, index) => {
                    return (
                      <option key={index} value={item.classe_id}>
                        {item.classe_designation}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="item">
              <label>Année scolaire</label>
              <div className="role-selector">
                <select
                  value={anneeDesignation}
                  onChange={(e) => setanneeDesignation(e.target.value)}
                  className="input-field"
                >
                  <option value="">--Selectionner annéec--</option>
                  {props.dataYear.map((item, index) => {
                    return (
                      <option key={index} value={item.annee_scolaire_id}>
                        {item.annee_scolaire_designation}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="item">
              <label>{"Frais scolaire"}</label>
              <input
                placeholder="Montant"
                type="text"
                value={montantDesignation}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="btn">
            <button onClick={() => props.setOpen(false)}>Annuler</button>
            {state.isLoading ? (
              <button>
                <LoaderIcon />
              </button>
            ) : (
              <button onClick={handleAddMontant}>Enregister</button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewFrais;
